import { BasicNumberFilterModel } from './basic-number-filter.model';
import { DiscoverListTypeEnum } from '../enum/discover-list-type.enum';
import { TargetingSearchApi } from '../../../api/targeting/model/targeting-search.api.model';
import { DiscoverListFilterApiModel } from './discover-list-filter-api.model';
import { deepCompare } from '../../../Core/utils';


export class DiscoverListFilterModel {
    discoverList: BasicNumberFilterModel;
    useEmploymentOutletId: boolean;
    discoverListType: DiscoverListTypeEnum;
    contactCount?: number;
    filterSearchId?: number;
    currentFilterSearchContext?: TargetingSearchApi;

    constructor(apiModel?: DiscoverListFilterApiModel) {
        if (apiModel) {
            this.discoverList = apiModel.discoverList;
            this.useEmploymentOutletId = apiModel.useEmploymentOutletId;
            this.discoverListType = apiModel.discoverListType;
            this.filterSearchId = apiModel.filterSearchId ? apiModel.filterSearchId : null;
            this.contactCount = null;
            this.currentFilterSearchContext = null;
        } else {
            this.discoverList = {
                include: [],
                exclude: []
            };
            this.useEmploymentOutletId = null;
            this.discoverListType = null;
            this.filterSearchId = null;
            this.contactCount = null;
            this.currentFilterSearchContext = null;
        }
    }

    toApiModel(): DiscoverListFilterApiModel {
        return {
            discoverList: this.discoverList,
            useEmploymentOutletId: this.useEmploymentOutletId,
            discoverListType: this.discoverListType,
            filterSearchId: this.filterSearchId ? this.filterSearchId : null
        };
    }


    equals(other: DiscoverListFilterModel): boolean {
        if (!other) {
            return false;
        }

        if (!deepCompare(this.discoverList, other.discoverList)) {
            return false;
        }

        if (this.useEmploymentOutletId !== other.useEmploymentOutletId) {
            return false;
        }

        if (this.discoverListType !== other.discoverListType) {
            return false;
        }
        if (this.filterSearchId !== other.filterSearchId) {
            return false;
        }

        return true;
    }

    clone(): DiscoverListFilterModel {
        const model: DiscoverListFilterModel = new DiscoverListFilterModel(this.toApiModel());
        model.contactCount = this.contactCount;
        model.currentFilterSearchContext = this.currentFilterSearchContext;
        return model;
    }
}
